module.exports = __webpack_public_path__ + "static/media/now-logo.e92b136e.png";